module.exports = __webpack_public_path__ + "static/media/riesgos_varios.4ba9865c.svg";